/* ============================================================
   KISHI KAISEI — retour en stock
   ------------------------------------------------------------
   Sur une fiche produit épuisée, propose « Prévenez-moi de son
   retour ». Le client déplie un champ email et laisse son adresse
   sans quitter la page.

   Où va l'adresse : dans Klaviyo, sous la forme d'un événement
   « Demande de retour en stock » portant le produit, la variante
   et le SKU. Ce n'est PAS une inscription à la newsletter et
   aucun consentement marketing n'est demandé : c'est une demande
   ponctuelle sur un produit précis.

   Ce qui n'est pas branché ici, volontairement : l'email de
   retour en stock lui-même. Les demandes sont enregistrées et
   attendent leur flux.
   ============================================================ */
(function () {
  'use strict';

  var KLAVIYO_ID = 'RxGHpT';
  var METRIQUE = 'Demande de retour en stock';
  var MEMOIRE = 'kk_restock';
  var MERCI = "C'est noté. Vous serez prévenu dès son retour.";

  var bloc = document.querySelector('[data-kk-restock]');
  if (!bloc) return;

  var source = bloc.querySelector('[data-kk-restock-data]');
  var data;
  try { data = JSON.parse(source.textContent); } catch (e) { return; }

  var ouvrir = bloc.querySelector('[data-kk-restock-open]');
  var form = bloc.querySelector('[data-kk-restock-form]');
  var champ = bloc.querySelector('[data-kk-restock-email]');
  var envoi = bloc.querySelector('[data-kk-restock-send]');
  var err = bloc.querySelector('[data-kk-restock-err]');
  var fait = bloc.querySelector('[data-kk-restock-done]');
  var eta = document.querySelector('[data-pdp-eta]');
  var idInput = document.querySelector('[data-variant-id]');

  var courante = null;

  function propre(v) { return (v || '').trim().toLowerCase(); }
  function valide(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  /* Mémoire de cet appareil : quelles variantes ont déjà été demandées.
     Elle ne franchit ni les navigateurs ni les appareils. Elle évite
     seulement de redemander son email à quelqu'un qui vient de le
     donner. Le vrai dédoublonnage est fait par Klaviyo, sur l'email. */
  function demandees() {
    try {
      var l = JSON.parse(localStorage.getItem(MEMOIRE) || '[]');
      return Object.prototype.toString.call(l) === '[object Array]' ? l : [];
    } catch (e) { return []; }
  }
  function retenir(id) {
    try {
      var l = demandees();
      if (l.indexOf(String(id)) === -1) {
        l.push(String(id));
        localStorage.setItem(MEMOIRE, JSON.stringify(l));
      }
    } catch (e) {}
  }
  function dejaDemande(id) { return demandees().indexOf(String(id)) !== -1; }

  function dire(msg) { err.textContent = msg; err.hidden = false; }
  function taire() { err.hidden = true; err.textContent = ''; }

  function confirmer() {
    form.hidden = true;
    ouvrir.hidden = true;
    fait.textContent = MERCI;
    fait.hidden = false;
  }

  function replier() {
    form.hidden = true;
    fait.hidden = true;
    ouvrir.hidden = false;
    ouvrir.setAttribute('aria-expanded', 'false');
    taire();
  }

  /* Affiche le bloc uniquement sur une variante épuisée, et retire au
     passage la fenêtre de livraison, qui n'a aucun sens sur un produit
     qu'on ne peut pas commander. */
  function sync() {
    var id = (idInput && idInput.value) ? String(idInput.value) : null;
    var v = (id && data.variantes) ? data.variantes[id] : null;
    var dispo = v ? v.dispo !== false : true;

    courante = id;
    bloc.hidden = dispo;
    if (eta) eta.hidden = !dispo;

    if (dispo) return;
    if (dejaDemande(id)) { confirmer(); } else { replier(); }
  }

  function enregistrer(email) {
    var v = (data.variantes && courante) ? data.variantes[courante] : null;
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: {
              'Produit': data.produit,
              'Variante': v ? v.titre : '',
              'SKU': v ? v.sku : '',
              'Variante ID': courante,
              'URL': data.url
            },
            metric: { data: { type: 'metric', attributes: { name: METRIQUE } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo');
      retenir(courante);
      return true;
    });
  }

  ouvrir.addEventListener('click', function () {
    form.hidden = false;
    ouvrir.setAttribute('aria-expanded', 'true');
    if (champ) champ.focus();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    taire();

    var email = propre(champ.value);
    if (!valide(email)) { dire('Vérifiez votre adresse email.'); return; }

    envoi.disabled = true;
    enregistrer(email).then(function () {
      confirmer();
    }).catch(function () {
      dire("Votre demande n'a pas pu être enregistrée. Réessayez dans un instant.");
    }).then(function () {
      envoi.disabled = false;
    });
  });

  /* Changement de variante : on repasse après le script du thème */
  Array.prototype.slice.call(document.querySelectorAll('[data-variant-select]'))
    .forEach(function (s) {
      s.addEventListener('change', function () { setTimeout(sync, 0); });
    });

  sync();
})();
